import { Inject } from '@odinjs/odin';
import { FormAPI, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute, ModulesRoute } from '../../constants';
import { Endpoint } from '../../constants/endpoints';
import showSuccessToast from '../../utils/show-toast';
import BaseController from '../BaseController';
import { DialogType, ModalType, SimpleDialog, SimpleDialogParams } from '../dialog-helper/dialog-helper';

@Controller({ fragment: 'inform-opinion-modal', component: 'layout-main' })
export class InformOpinionController extends BaseController {

  @Inject('form-inform-opinion')
    formOpinionRequestApi: FormAPI;

  @OnBeforeCancel({ target: 'form-inform-opinion' })
  onFormBeforeCancel(): void {

    const record = this.formOpinionRequestApi.getRecord();
    this.formOpinionRequestApi.setRecord(record);
    this.formOpinionRequestApi.setDisabled(true);

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: 'approval.discard.changes',
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel: () => { this.cancelDiscard();},
      onClickOk: () => { this.discard();},
      titleDialog: 'approvals.modal.title.inform-opinion',
      titleOnCancel: 'tws.form.cancel',
      titleOnOk: 'approval.discard',
      theme: ThemeTonalRange.VERY_DARK,
    };
    SimpleDialog.openDialog(dialogParams);
  }

  @OnBeforeSubmit({ target: 'form-inform-opinion' })
  onBeforeSubmit(event: SubmitEvent) : void {
    this.formOpinionRequestApi.setLoading(true);
    const { id, processId } = this.historyService.getCurrentRouteParams();
    const informOpinion = event as any;

    const body = {
      code: id as Value,
      processId: processId as Value,
      observation: informOpinion.record.observation,
    };

    HttpService.post(Endpoint.INFORM_OPINION, {}, { body }).then(() => {
      applicationContext.redirect(`${ModulesRoute.APPROVALS}${ApplicationRoute.APPROVAL_LIST}`);
      showSuccessToast('inform-opinion-complete-toast', 'pending.approval.action.completed.successfully');
    }).catch(err => {
      this.formOpinionRequestApi.setLoading(false);
      SimpleDialog.showErrorMessage(String(err), ThemeTonalRange.VERY_DARK);
      this.formOpinionRequestApi.setEditing(true);
    });
  }

  cancelDiscard(): void {
    this.formOpinionRequestApi.setDisabled(false);
    this.formOpinionRequestApi.setEditing(true);
  }

  discard(): void {
    applicationContext.redirect(
      `${ModulesRoute.APPROVALS}${ApplicationRoute.APPROVAL_LIST}`
    );
  }
}
